var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-sem"},[_c('NavBar',{attrs:{"active-menu":"sem"}}),_c('SearchSem')],1)}
var staticRenderFns = []

export { render, staticRenderFns }